import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import BoomiMahalli from "../../images/BoomiMahalli.svg";
import boomi1 from "../../images/boomi1.svg";
import boomi2 from "../../images/boomi2.svg";
import boomi3 from "../../images/boomi3.svg";

const RowBoomiMahalli = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row text-center">
        <div className="stickyRowHeaders4 col-lg-4 col-12 d-flex align-items-center justify-content-center ">
          <div className="d-lg-none d-inline">Boomi Mahalli</div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-30, 30]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                Boomi Mahalli
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-0 px-lg-4 bg-color-w py-2 py-lg-5">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-3 py-lg-5"
                : "fade-in-section row m-0 text-center py-3 py-lg-5"
            }
          >
            <div className="row mx-0 justify-content-center ">
              <img
                style={{ width: "200px" }}
                src={BoomiMahalli}
                alt="Boomi Mahalli"
              />
              <h2 className="dk-bold color-dk-boomi mt-3">
                The Symbol of Boomi Mahalli Products
              </h2>
              <div>
                <p className="color-dk-gray mt-3">
                  Boomi Mahalli was the most important movement of Digikala in
                  the field of corporate social responsibility with the aim of
                  empoweing local businesses, started life in Autumn 2021,
                  bringing a set of new product supply to Digikala. This project
                  is notable as it extends the development of Iran’s e-commerce
                  market to cities and villages located as far as thousands of
                  kilometers away from the capital.
                </p>
              </div>
              <div className="row my-2">
                <div className="col-4">
                  <div>
                    <img
                      className="factsC"
                      src={boomi1}
                      alt="Daily Fulfillment Capacity"
                    />
                  </div>
                  <div>
                    <h6 className="bg-color-gr dk-bold py-2 my-2 radius4 dk-medium">
                      3,485
                    </h6>
                  </div>
                  <div>
                    <p className="dk-smaller pt-1 text-center">
                      E-Commerce Support Centers Established
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div>
                    <img className="factsC" src={boomi2} alt="Assortments" />
                  </div>
                  <div>
                    <h6 className="bg-color-gr dk-bold py-2  my-2 radius4 dk-medium">
                      30,444
                    </h6>
                  </div>
                  <div>
                    <p className="dk-smaller pt-1 text-center">
                      Stock Keeping Units (SKUs)
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div>
                    <img
                      className="factsC"
                      src={boomi3}
                      alt="E-Commerce Support Centers Established"
                    />
                  </div>
                  <div>
                    <h6 className="bg-color-gr dk-bold py-2 my-2 radius4 dk-medium">
                      17
                    </h6>
                  </div>
                  <div>
                    <p className="dk-smaller pt-1 text-center">
                      E-Commerce Support Centers Established
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowBoomiMahalli;
